import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "bootstrap"

// Keeps the Track Time dropdown open through the two things that would
// otherwise tear it down mid-use:
//
//   1. Chip re-renders. Start, stop, and discard turbo-streams replace
//      #time-tracking-topbar's children (the chip state changed), which
//      destroys an open Bootstrap menu -- e.g. hitting play on a different
//      session inside the panel. This sits on the topbar <li> (never
//      replaced), watches for the swap, and re-shows the fresh menu; its
//      lazy panel frame then refetches, so the reopened panel reflects the
//      new state.
//   2. Modal clicks. The panel's buttons open modals in the layout's frame,
//      which is OUTSIDE the dropdown -- so cancelling or submitting one
//      reads to Bootstrap as an outside click (bs-auto-close="outside")
//      and closes the panel behind it. Those hides are cancelled here.
export default class extends Controller {
  connect() {
    this.observer = new MutationObserver((mutations) => this.chipSwapped(mutations))
    this.observer.observe(this.element, { childList: true })
    this.keepOpen = this.keepOpen.bind(this)
    // Bootstrap fires hide.bs.dropdown on the toggle; it bubbles to here.
    this.element.addEventListener("hide.bs.dropdown", this.keepOpen)
  }

  disconnect() {
    this.observer.disconnect()
    this.element.removeEventListener("hide.bs.dropdown", this.keepOpen)
  }

  // Only outside-click hides carry clickEvent, so keyboard/programmatic
  // closes (Escape, the toggle itself) still work normally.
  keepOpen(event) {
    const origin = event.clickEvent?.target
    if (origin?.closest(".modal, .modal-backdrop")) event.preventDefault()
  }

  chipSwapped(mutations) {
    const menuWasOpen = mutations.some((mutation) =>
      [...mutation.removedNodes].some((node) => node.querySelector?.(".dropdown-menu.show")))
    if (!menuWasOpen) return

    const toggle = this.element.querySelector("[data-bs-toggle='dropdown']")
    if (toggle) Dropdown.getOrCreateInstance(toggle).show()
  }
}
